import styled from "styled-components";
import {
  Type,
  Flex,
  Button,
  InputGroup,
} from "discover.medical.react-component-library";

export const StyledDialogMessage = styled(Type)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.md};
    font-style: italic;
    margin: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md} 0;
  }
`;

export const StyledRadioGroupLabel = styled(Type)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md} 0;
  }
`;

export const StyledInputGroup = styled(InputGroup)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg} ${({ theme }) => theme.space.md} 0;
  }
`;

export const StyledTypeButtonWrapper = styled(Flex)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg} 0 ${({ theme }) => theme.space.xl};
  }
`;

export const StyledCancelButton = styled(Button)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
    color: ${({ theme }) => theme.colors.anchor};
  }
`;
